import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

// multi-asset
import { ObjectUtils } from "@bfx/primeng/utils";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ATDLNControlType } from "../../data-atdl/enums/atdl-control-type.enum";
import { ATDLNLogicOperator } from "../../data-atdl/enums/atdl-logic-operator.enum";
import { ATDLNOperator } from "../../data-atdl/enums/atdl-operator.enum";
import { ATDLNParameterType } from "../../data-atdl/enums/atdl-parameter-type.enum";
import { ATDLDataModel } from "../../data-atdl/model/atdl-data.model";
import { ATDLEnumModel } from "../../data-atdl/model/atdl-enum.model";
import { ATDLInterfaceAuxiliaryModel } from "../../data-atdl/model/atdl-interface-auxiliary.model";
import { ATDLInterfaceControlModel } from "../../data-atdl/model/atdl-interface-control.model";
import { ATDLInterfaceDependencyModel } from "../../data-atdl/model/atdl-interface-dependency.model";
import { ATDLInterfaceLayoutModel } from "../../data-atdl/model/atdl-interface-layout.model";
import { ATDLLayoutControlModel } from "../../data-atdl/model/atdl-layout-control.model";
import { ATDLParameterDataModel } from "../../data-atdl/model/atdl-parameter-data.model";
import { ATDLValidationCaseModel } from "../../data-atdl/model/atdl-validation-case.model";
import { ATDLValidationGroupModel } from "../../data-atdl/model/atdl-validation-group.model";
import { ATDLValidationRuleModel } from "../../data-atdl/model/atdl-validation-rule.model";
import { ICDAutocompleteModel } from "../../data-idc/controls/icd-autocomplete.model";
import { ICDAuxCheckboxModel } from "../../data-idc/controls/icd-aux-checkbox.model";
import { ICDBaseModel } from "../../data-idc/controls/icd-base.model";
import { ICDCheckboxModel } from "../../data-idc/controls/icd-checkbox.model";
import { ICDClockModel } from "../../data-idc/controls/icd-clock.model";
import { ICDRadioInputModel } from "../../data-idc/controls/icd-radio-input.model";
import { ICDSpinnerModel } from "../../data-idc/controls/icd-spinner.model";
import { ICDTextFieldModel } from "../../data-idc/controls/icd-text-field.model";

export const ICD_CLOCK_TIME_PATTERN: RegExp = new RegExp(
  "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$",
);

export const ICD_TZ_CLOCK_TIME_PATTERN = new RegExp(
  "^(2[0-3]|[01][0-9]):?([0-5][0-9]):?([0-5][0-9])(Z|[+-](?:2[0-3]|[01][0-9])(?::?(?:[0-5][0-9]))?)?$",
);

export class ATDLUtilities {
  public static getValueFromICDBaseModel(valueModel: any, preferTextValue: boolean = false): any {
    if (valueModel instanceof ICDBaseModel) {
      if (
        valueModel.auxModel instanceof ICDAuxCheckboxModel &&
        valueModel.auxModel.enabled &&
        !valueModel.auxModel.value
      ) {
        return null;
      } else if (valueModel.disabled || valueModel.nulledByDependency) {
        return null;
      } else if (valueModel instanceof ICDCheckboxModel && typeof valueModel.enumRef === "string") {
        return valueModel.enumRef;
      } else if (
        preferTextValue &&
        valueModel instanceof ICDSpinnerModel &&
        valueModel.value instanceof CubiqTS.BigNumber
      ) {
        return valueModel.textValue;
      }
      return valueModel.value;
    } else if (valueModel instanceof CubiqTS.BigNumber) {
      return valueModel;
    } else if (
      valueModel != null &&
      (typeof valueModel === "string" ||
        typeof valueModel === "boolean" ||
        typeof valueModel === "number")
    ) {
      return valueModel;
    } else if (valueModel == null) {
      return null;
    } else {
      logger.out.error(
        `ERROR: atdlUtility.getValueFromICDBaseModel() Unknown valueModel type %O`,
        valueModel,
      );
      return null;
    }
  }

  public static fromString(name: string): ATDLNControlType {
    let localName: string = name;
    /* var nsIndex:int = localName.indexOf(':');
		if ( nsIndex >=0){
			localName = localName.substr(nsIndex +1);
		} */
    switch (localName) {
      case "CheckBox_t":
        return ATDLNControlType.CHECKBOX;
      case "CheckBoxList_t":
        return ATDLNControlType.CHECKBOX_LIST;
      case "Clock_t":
        return ATDLNControlType.CLOCK;
      case "DropDownList_t":
        return ATDLNControlType.DROPDOWN_LIST;
      case "HiddenField_t":
        return ATDLNControlType.HIDDEN;
      case "Label_t":
        return ATDLNControlType.LABEL;
      case "MultiSelectList_t":
        return ATDLNControlType.MULTI_SELECT_LIST;
      case "RadioButtonList_t":
        return ATDLNControlType.RADIO_LIST;
      case "SingleSelectList_t":
        return ATDLNControlType.SINGLE_SELECT_LIST;
      case "SingleSpinner_t":
        return ATDLNControlType.SINGLE_SPINNER;
      case "Slider_t":
        return ATDLNControlType.SLIDER;
      case "TextField_t":
        return ATDLNControlType.TEXTFIELD;
      default:
        throw new Error("Unknown control type: " + localName);
    }
  }

  public static convertStringToATDLNOperator(oprString: string): ATDLNOperator {
    if (typeof oprString === "string" && oprString.length === 2) {
      switch (oprString) {
        case "EX":
        case "ex":
          return ATDLNOperator.EX;
        case "NX":
        case "nx":
          return ATDLNOperator.NX;
        case "LE":
        case "le":
          return ATDLNOperator.LE;
        case "LT":
        case "lt":
          return ATDLNOperator.LT;
        case "GE":
        case "ge":
          return ATDLNOperator.GE;
        case "GT":
        case "gt":
          return ATDLNOperator.GT;
        case "EQ":
        case "eq":
          return ATDLNOperator.EQ;
        case "NE":
        case "ne":
          return ATDLNOperator.NE;
        default:
          throw new Error("Unknown ATDLNOperator type: " + oprString);
      }
    } else {
      throw new Error(`Invalid operator: %O` + oprString);
    }
  }

  public static convertStringToATDLNLogicOperator(oprString: string): ATDLNLogicOperator {
    if (typeof oprString === "string" && oprString.length >= 2 && oprString.length <= 3) {
      switch (oprString) {
        case "AND":
        case "and":
        case "And":
          return ATDLNLogicOperator.AND;
        case "OR":
        case "or":
        case "Or":
          return ATDLNLogicOperator.OR;
        case "XOR":
        case "xor":
        case "Xor":
          return ATDLNLogicOperator.XOR;
        case "NOT":
        case "not":
        case "Not":
          return ATDLNLogicOperator.NOT;
        default:
          throw new Error("Unknown ATDLNLogicOperator type: " + oprString);
      }
    } else {
      throw new Error(`Invalid operator: %O` + oprString);
    }
  }

  public static isSingleParamOperator(oprString: string | ATDLNOperator): boolean {
    let operator = oprString;
    if (typeof oprString === "string") {
      operator = this.convertStringToATDLNOperator(oprString);
    }
    return operator === ATDLNOperator.EX || operator === ATDLNOperator.NX;
  }

  public static convertXSITypeToParameterType(type: string): ATDLNParameterType {
    let retType: ATDLNParameterType;
    switch (type) {
      case "Amt_t":
        return ATDLNParameterType.AMT;
      case "Length_t":
        return ATDLNParameterType.LENGTH;
      case "NumInGroup_t":
        return ATDLNParameterType.NUMGROUP;
      case "TagNum_t":
        return ATDLNParameterType.TAGNUM;
      case "SeqNum_t":
        return ATDLNParameterType.SEQNUM;
      case "Boolean_t":
        return ATDLNParameterType.BOOLEAN_FIX;
      case "Char_t":
        return ATDLNParameterType.CHAR;
      case "Percentage_t":
        return ATDLNParameterType.PERCENT;
      case "Price_t":
        return ATDLNParameterType.PRICE;
      case "PriceOffset_t":
        return ATDLNParameterType.PRICE_OFFSET;
      case "Qty_t":
        return ATDLNParameterType.QTY;
      case "Float_t":
        return ATDLNParameterType.FLOAT;
      case "Country_t":
        return ATDLNParameterType.COUNTRY;
      case "Currency_t":
        return ATDLNParameterType.CURRENCY;
      case "Exchange_t":
        return ATDLNParameterType.EXCHANGE;
      case "Int_t":
        return ATDLNParameterType.INT;
      case "Language_t":
        return ATDLNParameterType.LANGUAGE;
      case "LocalMktDate_t":
        return ATDLNParameterType.DATE;
      case "MonthYear_t":
        return ATDLNParameterType.MONTHYEAR;
      case "MultipleCharValue_t":
        return ATDLNParameterType.MULTICHAR;
      case "MultipleStringValue_t":
        return ATDLNParameterType.MULTISTRING;
      case "String_t":
        return ATDLNParameterType.STRING;
      case "Tenor_t":
        return ATDLNParameterType.TENOR;
      case "TZTimeOnly_t":
        return ATDLNParameterType.TZTIMEONLY;
      case "TZTimestamp_t":
        return ATDLNParameterType.TZTIMESTAMP;
      case "UTCDateOnly_t":
        return ATDLNParameterType.UTCDATEONLY;
      case "UTCTimeOnly_t":
        return ATDLNParameterType.UTCTIMEONLY;
      case "UTCTimestamp_t":
        return ATDLNParameterType.UTCTIMESTAMP;
      case "Data_t": // Use default
      default:
        retType = ATDLNParameterType.STRING;
        break;
    }
    return retType;
  }

  /**
   * Convert the XML string representation of a control type to local Enum instance. Currently,
   * the type includes the actual NS prefix for the layout namespace - rather than check, we just
   * truncate anything found before a colon
   * @param name
   * @return
   *
   */
  public static convertStringToControlType(name: string): ATDLNControlType {
    let localName: string = name;
    let nsIndex: number = localName.indexOf(":");
    if (nsIndex >= 0) {
      localName = localName.substr(nsIndex + 1);
    }
    switch (localName) {
      case "CheckBox_t":
        return ATDLNControlType.CHECKBOX;
      case "CheckBoxList_t":
        return ATDLNControlType.CHECKBOX_LIST;
      case "Clock_t":
        return ATDLNControlType.CLOCK;
      case "DropDownList_t":
        return ATDLNControlType.DROPDOWN_LIST;
      case "HiddenField_t":
        return ATDLNControlType.HIDDEN;
      case "Label_t":
        return ATDLNControlType.LABEL;
      case "MultiSelectList_t":
        return ATDLNControlType.MULTI_SELECT_LIST;
      case "RadioButtonList_t":
        return ATDLNControlType.RADIO_LIST;
      case "SingleSelectList_t":
        return ATDLNControlType.SINGLE_SELECT_LIST;
      case "SingleSpinner_t":
        return ATDLNControlType.SINGLE_SPINNER;
      case "Slider_t":
        return ATDLNControlType.SLIDER;
      case "TextField_t":
        return ATDLNControlType.TEXTFIELD;
      default:
        return ATDLNControlType.UNSUPPORTED;
    }
  }

  public static equals<T = any>(object1: T, object2: T): boolean {
    return ObjectUtils.equals(object1, object2);
  }

  public static clone<T = any>(obj: T): T {
    let copy;
    // Handle the 3 simple types, and null or undefined
    if (obj == null || typeof obj != "object") return obj;
    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (let i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.clone(obj[i]);
      }
      return copy;
    }

    let ignorePrivateFields = false;
    // Handle Object
    if (obj != null && typeof obj === "object") {
      // Handle ATDLDataModel
      if (obj instanceof ATDLDataModel) {
        copy = new ATDLDataModel();
        ignorePrivateFields = true;
        // Handle ATDLInterfaceControlModel
      } else if (obj instanceof ATDLInterfaceControlModel) {
        copy = new ATDLInterfaceControlModel();
        // Handle ATDLInterfaceDependencyModel
      } else if (obj instanceof ATDLInterfaceDependencyModel) {
        copy = new ATDLInterfaceDependencyModel();
        // Handle ATDLInterfaceAuxiliaryModel
      } else if (obj instanceof ATDLInterfaceAuxiliaryModel) {
        copy = new ATDLInterfaceAuxiliaryModel();
        // Handle ATDLParameterDataModel
      } else if (obj instanceof ATDLParameterDataModel) {
        copy = new ATDLParameterDataModel();
        // Handle ATDLParameterEnumModel
      } else if (obj instanceof ATDLEnumModel) {
        copy = new ATDLEnumModel();
        // Handle ATDLInterfaceLayoutModel
      } else if (obj instanceof ATDLInterfaceLayoutModel) {
        copy = new ATDLInterfaceLayoutModel();
        // Handle ATDLLayoutControlModel
      } else if (obj instanceof ATDLLayoutControlModel) {
        copy = new ATDLLayoutControlModel();
        // Handle ATDLValidationCaseModel
      } else if (obj instanceof ATDLValidationCaseModel) {
        copy = new ATDLValidationCaseModel();
        // Handle ATDLValidationGroupModel
      } else if (obj instanceof ATDLValidationGroupModel) {
        copy = new ATDLValidationGroupModel();
        // Handle ATDLValidationRuleModel
      } else if (obj instanceof ATDLValidationRuleModel) {
        copy = new ATDLValidationRuleModel();
        // Handle ICD value models
      } else if (obj instanceof ICDAuxCheckboxModel) {
        copy = new ICDAuxCheckboxModel();
      } else if (obj instanceof ICDAutocompleteModel) {
        copy = new ICDAutocompleteModel();
      } else if (obj instanceof ICDSpinnerModel) {
        copy = new ICDSpinnerModel();
      } else if (obj instanceof ICDTextFieldModel) {
        copy = new ICDTextFieldModel();
      } else if (obj instanceof ICDClockModel) {
        copy = new ICDClockModel();
      } else if (obj instanceof ICDRadioInputModel) {
        copy = new ICDRadioInputModel();
      } else if (obj instanceof ICDCheckboxModel) {
        copy = new ICDCheckboxModel();
      } else if (CubiqTS.BigNumber.isBigNumber(obj)) {
        return new CubiqTS.BigNumber(obj) as T;
      } else if (obj instanceof Object === false) {
        // preserve NullProtoObject
        copy = Object.create(null);
      } else {
        copy = {};
      }

      for (let attr in obj) {
        // We want to allow caching of values so cannot clone these
        if (Object.hasOwn(obj, attr) && (!ignorePrivateFields || !attr.startsWith("_"))) {
          copy[attr] = this.clone(obj[attr]);
        }
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }

  public static compareTimeGreaterOrEqualThan(timeA: string, timeB: string): boolean {
    if (
      typeof timeA === "string" &&
      ICD_CLOCK_TIME_PATTERN.test(timeA) &&
      typeof timeB === "string" &&
      ICD_CLOCK_TIME_PATTERN.test(timeB)
    ) {
      let timeAArray = timeA.split(":");
      let timeBArray = timeB.split(":");
      if (
        timeAArray instanceof Array &&
        timeAArray.length === 3 &&
        timeBArray instanceof Array &&
        timeBArray.length === 3
      ) {
        // hours
        if (
          !isNaN(Number(timeAArray[0])) &&
          !isNaN(Number(timeBArray[0])) &&
          Number(timeAArray[0]) > Number(timeBArray[0])
        ) {
          return true;
        } else if (
          !isNaN(Number(timeAArray[0])) &&
          !isNaN(Number(timeBArray[0])) &&
          Number(timeAArray[0]) === Number(timeBArray[0])
        ) {
          // minutes
          if (
            !isNaN(Number(timeAArray[1])) &&
            !isNaN(Number(timeBArray[1])) &&
            Number(timeAArray[1]) > Number(timeBArray[1])
          ) {
            return true;
          } else if (
            !isNaN(Number(timeAArray[1])) &&
            !isNaN(Number(timeBArray[1])) &&
            Number(timeAArray[1]) === Number(timeBArray[1])
          ) {
            // seconds
            if (
              !isNaN(Number(timeAArray[2])) &&
              !isNaN(Number(timeBArray[2])) &&
              Number(timeAArray[2]) >= Number(timeBArray[2])
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        logger.out.error(
          `WARNING: atdlUtility.compareTime(): Comparison failed  => TimeA: '${timeA}' | TimeB: '${timeB}'`,
        );
        return false;
      }
    } else {
      logger.out.error(
        `WARNING: atdlUtility.compareTime(): Invalid time => TimeA: '${timeA}' | TimeB: '${timeB}'`,
      );
      return false;
    }
  }
}
